import { DraftActions } from "./DraftActions";
import { FinalisedActions } from "./FinalisedActions";
import {
  type DraftActionsProps,
  DraftStatus,
  type FinalisedActionsProps,
  FinalisedStatus,
  type InvoiceActionsProps,
  InvoiceMode,
} from "./types";

const renderActions = ({ mode, draftProps, finalisedProps }) => {
  switch (mode) {
    case "DRAFT":
      return <DraftActions {...draftProps} />;
    case "FINALISED":
      return <FinalisedActions {...finalisedProps} />;
    default:
      return <DraftActions {...draftProps} />;
  }
};

export const InvoiceActions = ({
  deleteInvoice,
  printInvoice,
  takePayment,
  voidInvoice,
  finaliseInvoice,
  refundInvoice,
  paymentHistory,
  displayOptions,
}: InvoiceActionsProps) => {
  const draftProps: DraftActionsProps = {
    draftStatus: (displayOptions?.status as DraftStatus) || DraftStatus.EMPTY,
    deleteInvoice,
    printInvoice,
    finaliseInvoice,
  };
  const finalisedProps: FinalisedActionsProps = {
    finalisedStatus:
      (displayOptions?.status as FinalisedStatus) || FinalisedStatus.UNPAID,
    printInvoice,
    refundInvoice,
    voidInvoice,
    takePayment,
    paymentHistory,
  };

  return renderActions({
    mode: displayOptions?.mode || InvoiceMode.DRAFT,
    draftProps,
    finalisedProps,
  });
};
